import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Breadcrumbs, { breadcrumbsClasses } from '@mui/material/Breadcrumbs';
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';

const StyledBreadcrumbs = styled(Breadcrumbs)(({ theme }: any) => ({
  margin: theme.spacing(1, 0),
  [`& .${breadcrumbsClasses.separator}`]: {
    color: (theme.vars || theme).palette.action.disabled,
    margin: 1,
  },
  [`& .${breadcrumbsClasses.ol}`]: {
    alignItems: 'center',
  },
}));

export default function NavbarBreadcrumbs() {
  const navigate = useNavigate();
  const currentPath = useLocation().pathname.split('/')[1];

  const pathToTitle: { [key: string]: string } = {
    dashboard: 'Início',
    profile: 'Perfil',
    payment: 'Meu plano',
    tutorials: 'Tutoriais',
    terms: 'Termos e Políticas'
  };

  const title = pathToTitle[currentPath] || '';

  return (
    <StyledBreadcrumbs
      aria-label="breadcrumb"
      separator={<NavigateNextRoundedIcon fontSize="small" />}
    >
      <Typography
        variant="body1"
        onClick={() => navigate('/dashboard')}
        sx={{ cursor: 'pointer' }}
      >
        Dashboard
      </Typography>
      <Typography variant="body1" sx={{ color: 'text.primary', fontWeight: 600 }}>
        {title}
      </Typography>
    </StyledBreadcrumbs>
  );
}